export const FuncIntro = {
  PreMedicalInterview: {
    Header: '事前問診とは',
    Paragraph1: {
      Header1: '■ 事前問診について',
      Body1: '「先に処方箋を送る（電子処方箋OK）」から',
      Body2: '調剤予約を完了すると"事前問診"に回答することができます。',
      Body3:
        '※問診とは、皆さまの体質やアレルギーの有無、既往歴や副作用歴、服用中のお薬など、より安全な服薬に繋がる大切な情報です。',
    },
    Paragraph2: {
      Header1: '■ ご利用者のメリット',
      Body1:
        '事前問診にご回答いただくことで、薬剤師が事前に問診への回答を確認したうえで、お薬の準備をすることができます。その結果、',
      Body2: 'お薬のお渡しがスムーズにできます。',
    },
    Paragraph3: {
      Header1: '■ 事前問診までの流れ',
      Body1: '事前問診は、調剤予約完了後、トップページに予約時間と同時に「',
      Body2: '事前問診を記入する',
      Body3: '」（下記図）が表示されたら、回答できます。',
    },
    Image: {
      Caption1: '▼事前問診が表示されている画面',
      Caption2: '▼事前問診の入力画面',
    },
  },
  OnlineMedicationGuide: {
    Header: 'オンライン服薬指導とは',
    Paragraph1: {
      Header1: '■ オンライン服薬指導について',
      Body1:
        'オンライン服薬指導とは、スマートフォン、タブレットなどのビデオ通話機能を使って、',
      Body2: 'ご自宅などで薬剤師からお薬の説明を受けられるサービスのこと',
      Body3: 'です。',
      Body4:
        '※お薬の内容によっては、薬局で対面による説明が必要になる場合があります。',
      Body5:
        '※お薬は、ご希望に応じてご自宅まで配送します。薬局でのお受け取りも可能です。ただし、',
      Body6:
        '「オンライン服薬指導と配送の組み合わせ」でお薬の受け取りを希望される場合、',
      Body7: 'クレジットカード決済',
      Body8: 'のみとなります。',
    },
    Paragraph2: {
      Header1: '■ ご利用者のメリット',
      Body1:
        '患者さんのご自宅等でご都合のつく時間帯を選んで、お薬の説明を受けることができるため、以下のようなメリットがあります。',
      Body2: '●時間の有効活用ができる',
      Body3: '●周囲を気にせずプライバシーも安心',
      Body4: '●感染症の予防に繋がる',
      Body5: '※お薬代は便利なオンライン決済が可能です。',
    },
    Paragraph3: {
      Header1: '■ オンライン服薬指導の流れ',
      Body1:
        'オンライン服薬指導を希望する場合は、受診の際にその旨とご利用希望の薬局を医師にお伝えください。処方箋は、医療機関から薬局へ直接送付されます。',
      Body2:
        'また、処方箋をご自身でご利用希望の薬局に持参したり、郵送することも可能です。',
      Body3:
        'その場合には、オンライン服薬指導の開始時間前までに処方箋原本が薬局に届くようにご提出ください。',
      Body4: '※処方箋の使用期間は、交付の日を含めて4日以内です。',
      Body5:
        '　4日以内には、休日や祝日が含まれるため、処方箋の使用期間が過ぎないようにご留意ください。',
      Body6:
        'オンライン服薬指導を受ける際は、「薬をもらう」のトップ画面より、調剤予約の中で「アプリで説明を受ける（オンライン服薬指導）」を選択してください。',
    },
    Image: {
      Caption1: '▼「薬をもらう」のトップ画面',
      Caption2:
        '▼調剤予約画面で「アプリで説明を受ける（オンライン服薬指導）」を選ぶ',
      Caption3: '▼「オンライン服薬指導」が選択されている画面',
    },
  },
  Delivery: {
    Header: 'お薬の配送について',
    Paragraph1: {
      Header1: '■ お薬の配送について',
      Body1: 'ご自宅などご指定の場所に翌日以降の配送',
      Body2: 'になります。',
      Body3: '＊',
      Body4: '一部地域では、当日中の受取も可能',
      Body5: 'です。当日配送可能な地域は、',
      Body6: '東京23区・横浜市・川崎市・名古屋市・大阪市・福岡市',
      Body7: 'になります（2023年2月6日時点）。',
      Body8: '＊配送料はご利用の薬局にお尋ねください。',
      Body9: '＊',
      Body10:
        '「オンライン服薬指導と配送の組み合わせ」でお薬の受け取りを希望される場合、',
      Body11: 'クレジットカード決済',
      Body12: 'のみとなります。',
    },
    Paragraph2: {
      Header1: '■ ご利用者のメリット',
      Body1: '●ご自宅でオンライン服薬指導、お薬は配送で受け取る事で',
      Body2: '自宅にいながら完結する',
      Body3: 'ため、感染症の予防に繋がります。',
      Body4:
        '●「薬局で説明を受ける」を選択された方もお薬の配送を依頼することで薬局で待つことなくお薬を受け取ることができます。',
    },
  },
};
